import actionTypes from './action-types';
import { resolveCurrency } from './helpers';

export default (state = {}, action) => {
    const initialize = () => {
        return {
            ...action.payload
        };
    };
    const setPreferredCurrency = () => {
        const { enabled, currencies } = state;
        return {
            ...state,
            preferredCurrency: resolveCurrency(
                enabled,
                action.payload.currencyCode,
                currencies
            )
        };
    };

    const def = () => state;

    const reducers = {
        [actionTypes.SET_PREFERRED_CURRENCY]: setPreferredCurrency
    };

    if (action.type === actionTypes.INITIALIZE) {
        return initialize();
    }

    return !state.enabled || !action || !action.type || !reducers[action.type]
        ? def()
        : reducers[action.type]();
};
